export const PLACEHOLDER_OPT = 'PLACEHOLDER';

export const baseSignupPath = 'rrSignupForms';
export const persInfoPath = `${baseSignupPath}.personalInfo`;
export const credentialsPath = `${baseSignupPath}.credentials`;
export const investmentInfoPath = `${baseSignupPath}.investmentInfo`;

export const baseLoginPath = 'loginForm';
export const baseForgotPwdPath = 'forgotPwdForm';
export const baseResetPwdPath = 'resetPwdForm';

export const changeCredentialsPath = 'changeCredentialsForm.changeCredentials';

export const baseTransferFundsPath = 'transferFundsForm';
export const transferFundsPath = `${baseTransferFundsPath}.transferFunds`;

export const baseOfferOrderPath = 'offerOrderForm';
export const offerOrderAmountPath = `${baseOfferOrderPath}.offerOrderAmount`;
export const offerOrderDisclosuresPath = `${baseOfferOrderPath}.offerOrderDisclosures`;
export const offerOrderTransferPath = `${baseOfferOrderPath}.offerOrderTransferFunds`;

export const baseExternalOfferOrderPath = 'externalOfferOrderForm';
export const externalOfferOrderAmountPath = `${baseExternalOfferOrderPath}.externalOfferOrderAmount`;
export const externalOfferOrderDisclosuresPath = `${baseExternalOfferOrderPath}.externalOfferOrderDisclosures`;
export const externalOfferOrderDeliveryPath = `${baseExternalOfferOrderPath}.externalOfferOrderDelivery`;
export const externalOfferOrderTransferPath = `${baseExternalOfferOrderPath}.externalOfferOrderTransferFunds`;

export const baseManageAccountPath = 'manageAccountForm';
export const baseSuitabilityPath = 'suitabilityForm';

export const baseTradeSecurityPath = 'tradeSecurityForm';
export const tradeSecurityPath = `${baseTradeSecurityPath}.tradeSecurity`;
export const tradeSecurityTransferPath = `${baseTradeSecurityPath}.tradeSecurityTransferFunds`;
export const tradeOrderTypePath = `${baseTradeSecurityPath}.tradeOrderType`;

export const baseUploadVerifyDocsPath = 'uploadVerifyDocsForm';
export const baseUploadDriverLicensePath = 'uploadDriverLicenseForm';

export const baseIndicateInterestPath = 'indicateInterestForm';

export const enumCountries = {
  [PLACEHOLDER_OPT]: 'Country',
  US: 'United States',
};

export const enumStates = {
  [PLACEHOLDER_OPT]: 'State',
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District of Columbia',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  VI: 'Virgin Islands, U.S.',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};

export const enumCitizenship = {
  [PLACEHOLDER_OPT]: 'Citizenship',
  C: 'U.S. Citizen',
  R: 'Resident Alien',
};

export const enumEmploymentStatus = {
  [PLACEHOLDER_OPT]: 'Employment Status',
  Employed: 'Employed',
  'Self-Employed': 'Self-Employed',
  Retired: 'Retired',
  Student: 'Student',
  Unemployed: 'Unemployed',
  Other: 'Other',
};

export const enumOccupationType = {
  [PLACEHOLDER_OPT]: 'Occupation Type',
  Administrative: 'Administrative',
  'Business Owner': 'Business Owner',
  Consulting: 'Consulting',
  Creative: 'Creative',
  Education: 'Education',
  Engineering: 'Engineering',
  Finance: 'Finance',
  'Health Care': 'Health Care',
  Homemaker: 'Homemaker',
  'Information Systems': 'Information Systems',
  Legal: 'Legal',
  Management: 'Management',
  Marketing: 'Marketing',
  Operations: 'Operations',
  'Other/Not Specified': 'Other/Not Specified',
  Sales: 'Sales',
  Service: 'Service',
  Training: 'Training',
};

export const enumTrustedContactRelationship = [
  ['', 'Choose a relationship', 'N/A'],
  ['S', 'Spouse'],
  ['A', 'Financial Advisor'],
  ['G', 'Guardian'],
  ['F', 'Family Member'],
  ['L', 'Lawyer/Attorney'],
  ['O', 'Other'],
];

/* eslint-disable quote-props */
export const enumAnnualIncome = [
  [PLACEHOLDER_OPT, 'Annual Income'],
  [1, '$0 to $25,000', 0, 25000],
  [2, '$25,001 to $50,000', 25001, 50000],
  [3, '$50,001 to $100,000', 50001, 100000],
  [4, '$100,001 to $200,000', 100001, 200000],
  [5, '$200,001 to $300,000', 200001, 300000],
  [6, '$300,001 to $500,000', 300001, 500000],
  [7, 'Greater than $500,000', 500001, 999999999999],
];

export const enumTotalNetWorth = [
  [PLACEHOLDER_OPT, 'Total Net Worth'],
  [1, '$0 to $25,000', 0, 25000],
  [2, '$25,001 to $50,000', 25001, 50000],
  [3, '$50,001 to $200,000', 50001, 200000],
  [4, '$200,001 to $500,000', 200001, 500000],
  [5, '$500,001 to $1,000,000', 500001, 1000000],
  [6, '$1,000,001 to $2,000,000', 1000001, 2000000],
  [7, '$2,000,001 to $3,000,000', 2000001, 3000000],
  [8, 'Greater than $3,000,000', 3000001, 999999999999],
];

export const enumLiquidNetWorth = [
  [PLACEHOLDER_OPT, 'Liquid Net Worth'],
  [1, '$0 to $25,000', 0, 25000],
  [2, '$25,001 to $50,000', 25001, 50000],
  [3, '$50,001 to $200,000', 50001, 200000],
  [4, '$200,001 to $500,000', 200001, 500000],
  [5, '$500,001 to $1,000,000', 500001, 1000000],
  [6, '$1,000,001 to $2,000,000', 1000001, 2000000],
  [7, '$2,000,001 to $3,000,000', 2000001, 3000000],
  [8, 'Greater than $3,000,000', 3000001, 999999999999],
];

export const enumSecurityOrderTypes = [
  // ['dm', 'Market Order'],
  ['dl', 'Limit Order'],
  // ['ds', 'Stop Order'],
  ['dsl', 'Stop Limit Order'],
];

export const enumSecurityOrderTerms = [
  ['DAY', 'End of Day'],
  ['GTC', 'Good Until Cancelled'],
];

export const initialCredentialsState = {
  // email: '',
  // passphrase: '',
  // verifyPassphrase: '',
};

export const initialSurveyState = {
  // passive: false,
  // hotStartups: false,
  // anything: false,
};

export const initialAddressState = {
  // line1: '',
  // line2: '',
  // city: '',
  state: PLACEHOLDER_OPT,
  // zipcode: '',
  country: PLACEHOLDER_OPT,
};

export const initialIdentityState = {
  // firstName: '',
  // middleInitial: '',
  // lastName: '',
  // dateOfBirth: '',
  // taxIdNum: '',
  // citizenship: PLACEHOLDER_OPT,
  residenceCountry: 'US',
  // primaryAddress: initialAddressState,
};

export const initialContactState = {
  // dayTelephone: '',
  // eveningTelephone: '',
};

export const initialPersonalInfoState = {
  // survey: initialSurveyState,
  identity: initialIdentityState,
  // contact: initialContactState,
};

export const initialEmploymentState = {
  // employmentStatus: PLACEHOLDER_OPT,
  // occupationType: PLACEHOLDER_OPT,
  // employerName: '',
  // employerAddress: initialAddressState,
};

export const initialFinancesState = {
  // annualIncome: PLACEHOLDER_OPT,
  // totalNetWorth: PLACEHOLDER_OPT,
  // liquidNetWorth: PLACEHOLDER_OPT,
};

export const initialDisclosuresState = {
  finraAffiliated: false,
  // finraCompany: '',
  directorOrTenPercentShareholder: false,
  // directorOrTenPercentShareholderCompany: '',
};

export const initialLoginState = {
  email: '',
  passphrase: '',
  ssn: '',
};

export const initialForgotPwdState = {
  email: '',
};

export const initialResetPwdState = {
  email: '',
  passphrase: '',
  verifyPassphrase: '',
};

export const initialInvestmentInfoState = {
  // employment: initialEmploymentState,
  // finances: initialFinancesState,
  disclosures: initialDisclosuresState,
};

export const initialTransferFundsState = {
  accounts: {
    from: PLACEHOLDER_OPT,
    to: PLACEHOLDER_OPT,
  },
};

// investment form
export const initialOrderAmountState = {
  requestedDollarAmount: 0,
  quantity: 0,
  // unrestricted: false,
};

export const initialOrderDisclosuresState = {
  reviewedDocuments: false,
  approvedShareValue: false,
};

export const initialOrderPaymentState = {
  from: PLACEHOLDER_OPT,
};

// external invest form
export const initialExternalOrderAmountState = {
  requestedDollarAmount: 0,
  quantity: 0,
  accreditation: 'NOT_ACCREDITED',
  // unrestricted: false,
};

export const initialExternalOrderDisclosuresState = {
  reviewedDocuments: false,
  approvedShareValue: false,
};

export const initialExternalOrderDeliveryState = {
  delivery: '',
};

export const initialExternalOrderPaymentState = {
  from: PLACEHOLDER_OPT,
};

// manage account form
export const initialManageAccountState = {
  email: '',
  phone: {
    dayTelephone: '',
    eveningTelephone: '',
  },
  address: {
    line1: '',
    line2: '',
    city: '',
    state: '',
    zipcode: '',
    country: '',
  },
  finances: {
    annualIncome: '',
    totalNetWorth: '',
    liquidNetWorth: '',
  },
  trustedContact: {
    firstName: '',
    lastName: '',
    email: '',
    telephone: '',
    relationship: '',
  },
};

// indicate interest form
export const initialIndicateInterest = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  state: '',
  investmentRange: '',
};

export const initialTradeOrderType = {
  type: enumSecurityOrderTypes[0][0],
};

export const initialTradeSecurityState = {
  // limitPrice: '',
  // stopPrice: '',
  // requestedShareAmount: '',
  term: enumSecurityOrderTerms[0][0],
};

export const initialChangeCrednetialsState = {
  currentPassphrase: '',
  newPassphrase: '',
  verifyNewPassphrase: '',
};

export const initialUploadVerifyDocsState = {
  type: PLACEHOLDER_OPT,
};

export const initialUploadDriverLicenseState = {
  type: PLACEHOLDER_OPT,
};

// suitability form
export const initialSuitabilityState = {
  financialSituation: {
    taxRate: '',
    annualExpenses: '',
    specialExpenses: '',
    timeFrameSpecialExpenses: '',
    liquidityNeeds: '',
  },
  investmentRiskTolerance: {
    riskTolerance: '',
    investmentObjectives: '',
  },
  investmentExperience: {
    mutualFunds: {
      hasValue: false,
      yearsOfExperience: '',
      transactionsPerYear: '',
    },
    commodities: {
      hasValue: false,
      yearsOfExperience: '',
      transactionsPerYear: '',
    },
    individualStocks: {
      hasValue: false,
      yearsOfExperience: '',
      transactionsPerYear: '',
    },
    bonds: {
      hasValue: false,
      yearsOfExperience: '',
      transactionsPerYear: '',
    },
    options: {
      hasValue: false,
      yearsOfExperience: '',
      transactionsPerYear: '',
    },
    securities: {
      hasValue: false,
      yearsOfExperience: '',
      transactionsPerYear: '',
    },
    annuities: {
      hasValue: false,
      yearsOfExperience: '',
      transactionsPerYear: '',
    },
    alternative: {
      hasValue: false,
      yearsOfExperience: '',
      transactionsPerYear: '',
    },
    margins: {
      hasValue: false,
      yearsOfExperience: '',
      transactionsPerYear: '',
    },
    reits: {
      hasValue: false,
      yearsOfExperience: '',
      transactionsPerYear: '',
    },
    decisionMaking: {
      consulting: false,
      own_decisions: false,
      family_decisions: false,
    },
  },
  investmentObjectives: {
    investments: '',
    investmentTimespan: '',
    fundingOption: {
      income: false,
      pension: false,
      otherFunds: false,
      gift: false,
      saleOfBusiness: false,
      insurancePayout: false,
      inheritance: false,
      socialSecurityBenefits: false,
      reverseMortgage: false,
      other: false,
      otherTextValue: '',
    },
  },
};

export const taxRateValues = {
  [PLACEHOLDER_OPT]: 'Tax Rates',
  '0_15': '0-15%',
  '16_25': '16-25%',
  '26_30': '26-30%',
  '31_35': '31-35%',
  'over_35': 'Over 35%',
};

export const expensesValues = {
  [PLACEHOLDER_OPT]: 'Expenses Range',
  '50_000_and_under': '$50,000 and under',
  '50_001-100_000': '$50,001 - $100,000',
  '100_001-250_000': '$100,001 - $250,000',
  '250_001-500_000': '$250,001 - $500,000',
  'over_500_000': 'Over $500,000',
};

export const specialExpensesValues = {
  [PLACEHOLDER_OPT]: 'Expenses Range',
  'none': 'None',
  '50_000_and_under': '$50,000 and under',
  '50_001-100_000': '$50,001 - $100,000',
  '100_001-250_000': '$100,001 - $250,000',
  '250_001-500_000': '$250,001 - $500,000',
  'over_500_000': 'Over $500,000',
};

export const timeFrameForSpecialExpensesValues = {
  [PLACEHOLDER_OPT]: 'Time Frames',
  'within_2_years': 'Within 2-years',
  '3_5_years': '3-5 years',
  '6_10_years': '6-10 years',
};

export const liquidityNeedsValues = {
  'very_important': 'Very Important',
  'somewhat_important': 'Somewhat Important',
  'does_not_matter': 'Not Important',
};

export const liquidityNeedsSubTexts = {
  'very_important': 'The ability to quickly and easily convert to cash all or a portion of the investments in under 5 years in this account is very important.',
  'somewhat_important': 'The ability to quickly and easily convert to cash all or a portion of the investments in this account in over 5 years is somewhat important.',
  'does_not_matter': 'The ability to quickly and easily convert to cash all or a portion of the investments in this account is not important.',
};

export const riskToleranceValues = {
  'conservative': 'Conservative',
  'moderately_conservative': 'Moderately Conservative',
  'moderate': 'Moderate',
  'moderately_aggressive': 'Moderately Aggressive',
  'significant_risk': 'Significant Risk',
};

export const riskToleranceSubTexts = {
  'conservative': 'I want to preserve my initial principal in this account, with minimal risk, even if that means this account does not generate significant income or returns and may not keep pace with inflation.',
  'moderately_conservative': 'I am willing to accept a low risk to my initial principal, including low volatility, to seek a modest level of portfolio returns.',
  'moderate': 'I am willing to accept some risk to my initial principal and tolerate some volatility to seek higher returns and understand I could lose a portion of the money invested.',
  'moderately_aggressive': 'I am willing to accept a high risk to my initial principal, including high volatility, to seek high returns over time, and understand I could lose a substantial amount of the money invested.',
  'significant_risk': 'I am willing to accept the maximum risk to my initial principal to aggressively seek maximum returns and understand I could lose most, or all, of the money invested.',
};

export const investmentObjectivesValues = {
  'capital_preservation': 'Capital Preservation',
  'income': 'Income',
  'growth': 'Growth',
  'maximum_growth': 'Maximum Growth',
  'speculation': 'Speculation',
};

export const investmentObjectivesSubTexts = {
  'capital_preservation': 'Preservation of capital with a primary consideration on income.',
  'income': 'A balance between capital appreciation and income with a primary consideration being income.  ',
  'growth': 'Capital appreciation through quality equity investment and little or no income.',
  'maximum_growth': 'Maximum capital appreciation with higher risk and little to no income.',
  'speculation': 'Maximum total return potential, involving a higher degree of risk through investment in a broad spectrum of securities.',
};

export const yearsOfExperience = {
  [PLACEHOLDER_OPT]: 'Years of Experience',
  'ZERO': '0',
  '1-5': '1-5',
  'over_5': 'Over 5',
};

export const transactionsPerYear = {
  [PLACEHOLDER_OPT]: 'Transactions per year',
  '0_5': '0-5',
  '6_15': '6-15',
  'over_15': 'Over 15',
};

export const financialInvestmentExperienceLabels = {
  individualStocks: 'Stocks',
  options: 'Options',
  bonds: 'Bonds',
  margins: 'Margin',
  mutualFunds: 'Mutual Funds/ETFs',
  commodities: 'Commodities',
  securities: 'Securities Futures',
  annuities: 'Annuities',
  alternative: 'Alternative (structured products, hedge funds, etc...)',
  reits: 'REITs',
  decisionMaking: 'Decision Making',
};

export const decisionMakingOptions = {
  consulting: 'I consult with my broker, investment adviser, CPA, or other financial professional',
  own_decisions: 'I generally make my own decisions and/or consult with my co-applicant(s).',
  family_decisions: 'I discuss investment decisions with family and/or friends.',
};

export const investmentOptions = {
  'less_than_1_3': 'Less than 1/3 of my financial portfolio',
  '1_3-2_3': 'Roughly 1/3 to 2/3 of my financial portfolio',
  'more_than_2_3': 'More than 2/3 of my financial portfolio',
};

export const investmentTimespanOptions = {
  'short': 'Short',
  'average': 'Average',
  'longest': 'Longest',
};

export const investmentTimespanSubTexts = {
  'short': 'I plan on keeping this account open and investing for less than 4 years to achieve my financial goals.',
  'average': 'I plan on keeping this account open and investing for more than 5 years, but less than 7 years to achieve my financial goals.',
  'longest': 'I plan on keeping this account open and investing for more than 8+ years to achieve my financial goals.',
};

export const fundingOptionLabels = {
  income: 'Income',
  pension: 'Pension or retirement savings',
  otherFunds: 'Funds from another account',
  gift: 'Gift',
  saleOfBusiness: 'Sale of business or property',
  insurancePayout: 'Insurance payout',
  inheritance: 'Inheritance',
  socialSecurityBenefits: 'Social Security benefits',
  reverseMortgage: 'Home Equity Line of Credit/Reverse Mortgage',
  other: 'Other',
};

// eslint-disable-next-line no-useless-escape
export const folioAllowedSpecialChars = /[\wa-zA-Z0-9\s~`!@#$%^&*()_+\-=\[\{\]\}|:',.\/? ]/g;



// WEBPACK FOOTER //
// ./src/components/Forms/Schemas/baseRrf.js